module.exports = __webpack_public_path__ + "img/renyuan.bd1e2cb4.png";